export default __webpack_public_path__ + "static/media/arctradeLogo_type.52ea7610.png";